var map = {
	"./components/admin/admin.module": [
		"./src/app/components/admin/admin.module.ts",
		"components-admin-admin-module"
	],
	"./components/admin/guestreg/guestreg-archive/guestreg-archive.module": [
		"./src/app/components/admin/guestreg/guestreg-archive/guestreg-archive.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"guestreg-guestreg-archive-guestreg-archive-module"
	],
	"./components/admin/guestreg/guestreg.module": [
		"./src/app/components/admin/guestreg/guestreg.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"guestreg-guestreg-module"
	],
	"./components/public/login/login.module": [
		"./src/app/components/public/login/login.module.ts",
		"components-public-login-login-module"
	],
	"./components/public/register/register.module": [
		"./src/app/components/public/register/register.module.ts",
		"components-public-register-register-module"
	],
	"./guestreg/guestreg-archive/guestreg-archive.module": [
		"./src/app/components/admin/guestreg/guestreg-archive/guestreg-archive.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"guestreg-guestreg-archive-guestreg-archive-module"
	],
	"./guestreg/guestreg.module": [
		"./src/app/components/admin/guestreg/guestreg.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"guestreg-guestreg-module"
	],
	"./help/help.module": [
		"./src/app/components/admin/help/help.module.ts",
		"help-help-module"
	],
	"./menu/menu.module": [
		"./src/app/components/admin/menu/menu.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"menu-menu-module"
	],
	"./orders/orders-archive/orders-archive.module": [
		"./src/app/components/admin/orders/orders-archive/orders-archive.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"orders-orders-archive-orders-archive-module"
	],
	"./orders/orders.module": [
		"./src/app/components/admin/orders/orders.module.ts",
		"default~guestreg-guestreg-archive-guestreg-archive-module~guestreg-guestreg-module~menu-menu-module~~fab7c3c5",
		"orders-orders-module"
	],
	"./settings/settings.module": [
		"./src/app/components/admin/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./tables/table-details/table-details.module": [
		"./src/app/components/admin/tables/table-details/table-details.module.ts",
		"tables-table-details-table-details-module"
	],
	"./tables/tables.module": [
		"./src/app/components/admin/tables/tables.module.ts",
		"tables-tables-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;